/* copy: internal — the donor's page script, externalized unchanged except two lines (subscription label, one-time ship line) */

$(document).ready(function(){
	$(".btn_scorall").click(function() {
		/* 2026-09-24 publish: the donor's 2 s animate landed 63-69 px short on desktop and 396 px on mobile because lazy images above the
		   target loaded during the scroll and pushed it down. Load them first, then correct once against the re-measured offset. */
		document.querySelectorAll('img[loading="lazy"]').forEach(function(i){ i.loading = 'eager'; });
		var tgt = $("#slct-pkg"); var y = tgt.offset().top; var tries = 0;
		function settle() {
			var y2 = tgt.offset().top; var off = y2 - $(window).scrollTop();
			if (Math.abs(off) > 2 && tries++ < 24) { $('html, body').stop(true).animate({ scrollTop: y2 }, 200, function() { setTimeout(settle, 150); }); }
			else if (tries++ < 24) { setTimeout(settle, 250); }
		}
		$('html, body').stop(true).animate({ scrollTop: y }, 1200, function() { setTimeout(settle, 100); });
	});
	
	/*SLIDER_FOR_SECTION1_START*/
	
	const thumbSwiper = new Swiper(".sec1_thumbSwiper", {
		spaceBetween:5,
		slidesPerView:5,
		slideToClickedSlide: true,
		watchSlidesProgress: true,
		
		breakpoints: {
			0: {
				slidesPerView:5,
				spaceBetween:0,
				
			},
			768: {
				slidesPerView: 5,
				spaceBetween:8,
				
			},

			1024: {
				spaceBetween: 8,
				slidesPerView:5,
				slideToClickedSlide: true,
				watchSlidesProgress: true,
			}
		  },
	});
	
	const mainSwiper = new Swiper(".sec1_mainSwiper", {
		spaceBetween:15,
		slidesPerView:1.1,
		loop: true,
		speed: 600,
		centeredSlides: true,
		
		thumbs: {
			swiper: thumbSwiper,
		},
		
		navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
		
		pagination: {
			el: ".s1-swiper-pagination",
			clickable: true,
		},
		
		breakpoints: {
			768: {
				slidesPerView: 3,
				spaceBetween:20,
				
			},

			1024: {
				centeredSlides: true,
				slidesPerView: 3,
				spaceBetween: 21,
			}
		  },
	});
	
	/*SLIDER_FOR_SECTION1_END*/
	
	// for slider
	var swiper = new Swiper(".video_slide_row", {
		spaceBetween:15,
		slidesPerView:1.5,
		loop: true,

		navigation: {
		  nextEl: ".video_slide-button-next",
		  prevEl: ".video_slide-button-prev",
		},
		
		 pagination: {
			el: ".swiper-pagination",
			clickable: true,
		  },
		  
		
		breakpoints: {
			0: {slidesPerView:1.3, spaceBetween:15, parallax:true, centeredSlides: true,},
			768: {slidesPerView:3,centeredSlides: false,},
			// 🖥 Desktop
			1021: { slidesPerView:4,spaceBetween:15,centeredSlides: false,},
		},
	});
	
	$('.more-review').click(function(e) {
		$('.testimonial-hide').fadeIn();
		$('.more-review-link').hide();
	});
	
	//video
	var video = $('#myVdo video')[0];
	
	$('.ugc1').click(function(e) {
		$('.ugc-modal').addClass('active');
		$('.video-container').show();
		
		var videoFile = $(this).attr('data-vdo');
		video.src = videoFile;
		video.load();
		video.play();
    });	
	
	$('.ugc-close, .ugc-modal').click(function(e) {
		video.src = '';
       	$('.ugc-modal').removeClass('active');
	   	$('.video-container').hide();
    });
	
	//Accordion JS 
	$(".acdn-heading").click(function() {
			
		var questionDiv = $(this);
		var answerDiv   = $(this).next('.acdn-content');
		var idx = $('.acdn-content').index(answerDiv);
		
		$('.acdn-content').each(function(index, ansDiv) {
			if(index != idx && $(ansDiv).is(':visible')) {
				$(ansDiv).slideUp(500, function() {
					$(ansDiv).prev('.acdn-heading').removeClass('accordion-open');
				});
			}
		});
					
		if (answerDiv.is(':visible')) {
			answerDiv.stop().slideUp(500, function() {
				questionDiv.removeClass('accordion-open');
			});
		} else {
		  questionDiv.addClass('accordion-open');
		  answerDiv.stop().slideDown(500);
		}
	
	});
	
	/*PACKAGE_SEC*/
	$('.purchase-box-inner').on('click', function () {

			var $this = $(this);
			var $parent = $this.closest('.package');

			$parent.find('.purchase-box-inner').removeClass('active');
			$this.addClass('active');
		
			$parent.find('.purchase-check').prop('checked', false);
			$this.find('.purchase-check').prop('checked', true);
		
			$parent.find('.pck-cutpr').html($this.attr('data-cut'));
			$parent.find('.pkage_offer-price').html($this.attr('data-each'));
		
			var isAutoship = $this.find('.purchase-heading')
				.text()
				.trim()
				.includes('Autoship') || $this.find('.purchase-heading').text().trim().includes('Subscribe');
		
			if (isAutoship) {
		
				$parent.find('.subs-seal').show();
				$parent.find('.ship-text').text('Free Shipping');
		
			} else {
		
				$parent.find('.subs-seal').hide();
				$parent.find('.ship-text').text('+$10 S&H');
		
			}
			
			const link = $(this).data('link');
	
			$(this).closest('.package').find('.package_btn').attr('href', link);
		
		});
	
	//Discount Timer
	clock();
	
		
});

var myTimer;

function clock() {
    var totalSeconds = 3 * 55 * 60; // 3 hours 55 minutes

    myTimer = setInterval(myClock, 1000);
	
	myClock(); // Show initial time immediately

    function myClock() {
        var hours = Math.floor(totalSeconds / 3600);
        var minutes = Math.floor((totalSeconds % 3600) / 60);
        var seconds = totalSeconds % 60;

        // Add leading zeros
        hours = String(hours).padStart(2, "0");
        minutes = String(minutes).padStart(2, "0");
        seconds = String(seconds).padStart(2, "0");

        var result = hours + ":" + minutes + ":" + seconds;

        var countdown2 = document.getElementsByClassName("listicle-count");

        for (var index = 0; index < countdown2.length; index++) {
            countdown2[index].innerHTML = result;
        }

        // Stop at 00:00:00
        if (totalSeconds <= 0) {
            clearInterval(myTimer);
            return;
        }

        totalSeconds--;
    }
    
}
